<template>
  <textarea class="w-full h-32 rounded-lg p-4 text-sm overflow-y-auto resize-none"
            ref="textarea"
            :class="[`color-${color}`]"
            :value="value"
            :disabled="disabled"
            :placeholder="placeholder"
            @input="$emit('input', $event.target.value)"
            @focusout="onEvent"
  />
</template>

<script>
export default {
  name: 'GrmTextarea',
  props: {
    value: { type: String,  default: '' },
    color: { type: String,  default: 'gray' },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
  },
  methods: {
    onEvent(event) {
      this.$emit(event.type, event);
    },
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar { display: none; }

.color-gray { @apply bg-gray-100; }
.color-blue { @apply bg-blue-50; }
.color-red { @apply bg-red-50; }
</style>